import React from 'react';
import { NavHashLink } from 'react-router-hash-link';
import styles from "./NavBar.module.css";

const DEFAULT_CLASSES = {
  container: styles.navbar,
  logoContainer: styles["navbar-logo"],
  logoImage: styles["navbar-logo-image"],
  navList: styles["navbar-nav"],
  navItemContainer: null,
  navItem: styles["nav-link"],
  navItemActive: styles.active,
  navBadge: styles.cartBadge,
  navIcon: styles.navIcon
};

const DEFAULT_LOGO = {
  image: null,
  path: "/"
};

function NavBar({ 
  navItems = [], 
  navLogo = {}, 
  navClassesOverride = {}, 
  navStyles = {} 
}) {

  const classes = { ...DEFAULT_CLASSES, ...navClassesOverride };
  const logo = { ...DEFAULT_LOGO, ...navLogo };

  return (
    <nav className={classes.container} style={navStyles.container}>
      <div className={classes.logoContainer} style={navStyles.logoContainer}>
        <a href={logo.path}>
          <img 
            src={logo.image} 
            alt="Logo" 
            className={classes.logoImage}
            style={navStyles.logoImage}
          />
        </a>
      </div>

      <ul className={classes.navList} style={navStyles.navList}>
        {navItems.map((item) => (
          <li key={item.name} className={classes.navItemContainer} style={navStyles.navItemContainer}>
            <NavHashLink
              smooth
              to={item.path}
              onClick={() => {
                if (item.scrollToTop) {
                  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
                }
              }}
              className={classes.navItem}
              activeClassName={classes.navItemActive}
              style={{...navStyles.navItem, ...item.style}}
              isActive={(match, location) => {
                if (!match) return false;
                if (item.path.includes("#")) {
                  const hash = item.path.substring(item.path.indexOf("#"));
                  return location.hash === hash;
                }
                return location.pathname === item.path;
              }}
            >
              {item.name}

              {item.badge && item.badge.value > 0 && (
                <span className={classes.navBadge} style={navStyles.navBadge}>
                  {item.badge.value}
                </span>
              )}
              {item.icon && (
                <span className={classes.navIcon} style={navStyles.navIcon}>
                  {item.icon}
                </span>
              )}
            </NavHashLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default NavBar;